// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UfDMT","name":"Header_name__LXPZa","birthday":"Header_birthday__1o21e","skeleton":"Header_skeleton__1ZMej"};